const TARGET_LANGUAGE = process.env.GATSBY_TARGET_LANGUAGE || "en";

const SITE_URLS = {
  en: process.env.GATSBY_EN_SITE_URL || "https://xltools.net",
  ru: process.env.GATSBY_RU_SITE_URL || "https://xltools.ru",
};

const SITE_URL =
  process.env.GATSBY_SITE_URL || SITE_URLS[TARGET_LANGUAGE] || SITE_URLS.en;

const locales = {
  en: {
    default: true,
    path: "",
    regex: "/en/",
    locale: "en-US",
    dateFormat: "DD/MM/YYYY",
    siteLanguage: "en",
    siteUrl: SITE_URLS.en,
    text: "English (US)",
    ogLanguage: "en_US",
    defaultTitle:
      "XLTools Add-in for Excel | Clean data, track changes, automate tasks",
    defaultDescription:
      "XLTools helps you clean data, compare spreadsheets, track changes, automate Excel tasks, and work faster without VBA.",
  },
  ru: {
    default: true,
    path: "",
    regex: "/ru/",
    locale: "ru-RU",
    dateFormat: "DD.MM.YYYY",
    siteLanguage: "ru",
    siteUrl: SITE_URLS.ru,
    text: "Русский (RU)",
    ogLanguage: "ru_RU",
    defaultTitle:
      "XLTools для Excel | Очистка данных, сравнение файлов, автоматизация",
    defaultDescription:
      "XLTools помогает очищать данные, сравнивать таблицы, отслеживать изменения и автоматизировать задачи в Excel без VBA.",
  },
};

module.exports = {
  SITE_URL,
  SITE_URLS,
  TARGET_LANGUAGE,
  locales,
};
